import React from 'react';
import { Outlet } from 'react-router-dom';
import { ParentProvider } from '../context/ParentContext';
import ParentSidebar from './layout/ParentSidebar';
import ParentMobileNavigation from './layout/ParentMobileNavigation';
import DevDemoControls from './DevDemoControls';
import './layout/ParentLayout.css';

/**
 * Parent Portal application shell.
 * Wraps all parent routes with context, sidebar, and responsive navigation.
 * Mirrors AppLayout pattern but with parent-specific nav and content.
 */
function ParentLayout() {
  return (
    <ParentProvider>
      <div className="parent-layout">
        <ParentSidebar />
        <main className="parent-layout__main">
          <Outlet />
        </main>
        <ParentMobileNavigation />
        {process.env.NODE_ENV !== 'production' && <DevDemoControls />}
      </div>
    </ParentProvider>
  );
}

export default ParentLayout;
